import createTrackingClient from '@seek/seek-impression-tracking';
import Cookies from 'js-cookie';

import {
  IMPRESSION_TRACKING_ENABLED,
  IMPRESSION_TRACKING_URL,
} from 'src/config';
import { log } from 'src/modules/error-logger';

const TIMED_REQUEST_INTERVAL_MILLISECONDS = 500;
const windowDefined = typeof window !== 'undefined';
const sessionId = windowDefined ? Cookies.get('JobseekerSessionId') : null;

const trackingClient =
  windowDefined && IMPRESSION_TRACKING_ENABLED
    ? createTrackingClient(IMPRESSION_TRACKING_URL, {
        params: sessionId ? { sessionId } : {},
        errorLogger: (message) =>
          log(new Error(message), {
            name: 'trackingFailure',
          }),
        // @ts-expect-error field isn't present in the type, leaving it here just in case
        timedRequestInterval: TIMED_REQUEST_INTERVAL_MILLISECONDS,
      })
    : undefined;

const noop = () => {};
const trackUnconfirmedDataNudgeImpression =
  trackingClient?.trackUnconfirmedDataNudgeImpression || noop;

export { trackUnconfirmedDataNudgeImpression };
